import React, { ComponentProps, FunctionComponent, ReactNode, useEffect, useRef } from 'react'
import classNames from 'classnames'

function isNullish(value: any): value is null | undefined {
  return value === null || typeof value === 'undefined'
}

type TextProps = {
	state: any
	labelPosition?: string
	className?: string
	placeholder?: string
	name?: string
	children?: ReactNode
	type?: ComponentProps<'a'>['type']
}
export const Text: FunctionComponent<TextProps> = ({state, children, labelPosition = 'before', className = '', placeholder = '', name = '', type = 'text'}) => {
	const [value, setValue] = state
	return <label className={classNames('text-label', 'input-label', className)}>
		{labelPosition === 'before' ? <div className="texet-label-container input-label-container">{children}</div> : null }
		<input type={type} name={name} value={isNullish(value) ? '' : value} onChange={e => setValue(e.target.value)} placeholder={placeholder} />
		{labelPosition === 'after' ? <div className="texet-label-container input-label-container">{children}</div> : null }
	</label>
}

export function Textarea({state, children, labelPosition = 'before', className = '', name = ''}){
	const [value, setValue] = state
	return <label className={classNames('textarea-label', 'input-label', className)}>
		{labelPosition === 'before' ? <div className="texetarea-label-container input-label-container">{children}</div> : null}
		<textarea name={name} value={isNullish(value) ? '' : value} onChange={e => setValue(e.target.value)} rows={3}/>
		{labelPosition === 'after' ? <div className="texetarea-label-container input-label-container">{children}</div> : null}
	</label>
}

export function Checkbox({state, children, name = '', indeterminate = false, onChange = (value: boolean) => {}}){
	const [checked, setChecked] = state
	const inputRef = useRef<HTMLInputElement>(null)
	useEffect(() => {
		if(typeof indeterminate === 'boolean' && inputRef.current){
			inputRef.current.indeterminate = indeterminate
		}
	}, [indeterminate])
	return <label className={classNames('checkbox-label', 'input-label', {checked: checked})}>
		<input ref={inputRef} type="checkbox" name={name} checked={checked} onChange={e => {
			setChecked(e.target.checked)
			onChange(e.target.checked)
		}}/>
		<div className="checkbox-label-container input-label-container">{children}</div>
	</label>
}

export function Select({state, options, children, name = '', hideValue = false}: any){
	const [currentValue, setCurrentValue] = state
	return <>
		<label className="select-label input-label">
			<div className="select-label-container input-label-container">{children}</div>
			<div className="select-value">
				{hideValue || options[currentValue]}
				<select name={name} value={currentValue} onChange={e => setCurrentValue(e.target.value)}>
					{
						Object.entries(options).map(([value, label]) => {
							return <option key={value} value={value}>{label as any}</option>
						})
					}
				</select>
			</div>
		</label>
	</>
}

export function If({cond, children}){
	if(cond){
		return <>
			{children}
		</>	
	} else {
		return <></>
	}
}